__webpack_require__.p = "https://jdih.magelangkota.go.id/";